import { render, staticRenderFns } from "./ShootingCard.vue?vue&type=template&id=28905987&"
import script from "./ShootingCard.vue?vue&type=script&lang=js&"
export * from "./ShootingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports